import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=73c4c7ca"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"
import style0 from "./blank.vue?vue&type=style&index=0&id=73c4c7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports